// import axios from "axios";

// export default axios.defaults.baseURL = "https://admin.dollarempirellc.com";

// const token = JSON.parse(window.localStorage.getItem("token"));

// export const PostUrl = axios.create({
//   baseURL: "https://admin.dollarempirellc.com/api",
//   method: "post",
//   headers: {
//     "Accept-Language": JSON.parse(window.localStorage.getItem("user_lang")),
//     Authorization: token,
//   },
// });

// export const GetUrl = axios.create({
//   baseURL: "https://admin.dollarempirellc.com/api",
//   method: "get",
//   headers: {
//     "Accept-Language": JSON.parse(window.localStorage.getItem("user_lang")),
//     Authorization: token,
//   },
// });


// import axios from "axios";
 
// // Base URL for .concat usage
// const BaseUrl = "https://admin.dollarempirellc.com";
 
// // JWT token as string
// let token = window.localStorage.getItem("token") || "";
 
// // Remove quotes if accidentally stored as JSON string
// if (token.startsWith('"') && token.endsWith('"')) {
//   token = token.slice(1, -1);
// }
 
// // User language
// const userLang = window.localStorage.getItem("user_lang") || "en";
 
// // Axios instances
// export const PostUrl = axios.create({
//   baseURL: `${BaseUrl}/api`,
//   method: "post",
//   headers: {
//     "Accept-Language": userLang,
//     Authorization: token ? `Bearer ${token}` : "",
//   },
// });
 
// export const GetUrl = axios.create({
//   baseURL: `${BaseUrl}/api`,
//   method: "get",
//   headers: {
//     "Accept-Language": userLang,
//     Authorization: token ? `Bearer ${token}` : "",
//   },
// });
 
// export default BaseUrl;



 
import axios from "axios";
 
const getSafeToken = () => {
  const raw = window.localStorage.getItem("token");
 
  if (!raw) return "";
 
  // case 1: already clean JWT
  if (raw.startsWith("ey")) return raw;
 
  // case 2: JSON string => "eyJhbGciOi..."
  if (raw.startsWith('"')) {
    try {
      return JSON.parse(raw);
    } catch {
      return raw.replace(/"/g, "");
    }
  }
 
  // case 3: object => { token: "ey..." }
  try {
    const parsed = JSON.parse(raw);
    return parsed?.token || "";
  } catch {
    return "";
  }
};
 
 
// Base URL for .concat usage
const BaseUrl = "https://admin.dollarempirellc.com";
 
// JWT token as string
// let token = window.localStorage.getItem("token") || "";
 
// Remove quotes if accidentally stored as JSON string
// if (token.startsWith('"') && token.endsWith('"')) {
//   token = token.slice(1, -1);
// }
const token = getSafeToken();
 
 
// User language
const userLang = window.localStorage.getItem("user_lang") || "en";
 
// Axios instances
export const PostUrl = axios.create({
  baseURL: `${BaseUrl}/api`,
  method: "post",
  headers: {
    "Accept-Language": userLang,
    Authorization: token ? `Bearer ${token}` : "",
  },
});
 
export const GetUrl = axios.create({
  baseURL: `${BaseUrl}/api`,
  method: "get",
  headers: {
    "Accept-Language": userLang,
    Authorization: token ? `Bearer ${token}` : "",
  },
});
 
if (token) {
  window.localStorage.setItem("token", token);
}
 
export default BaseUrl;
 


